import {
  Bolt as BoltIcon,
  Schedule as ClockIcon,
  WorkOutline as WorkIcon,
} from "@mui/icons-material";
import { Box, Stack } from "@mui/material";
import { ORANGE, INK, INK_4, LINE, PAPER } from "./types";

export type TimelineFilter =
  | "all"
  | "open"
  | "cases"
  | "activities"
  | "future";

interface ChipDef {
  value: TimelineFilter;
  label: string;
  count: number;
  icon?: React.ReactNode;
}

interface TimelineFiltersProps {
  value: TimelineFilter;
  onChange: (v: TimelineFilter) => void;
  counts: {
    all: number;
    open: number;
    cases: number;
    activities: number;
    future: number;
  };
}

const TimelineFilters = ({
  value,
  onChange,
  counts,
}: TimelineFiltersProps) => {
  const chips: ChipDef[] = [
    { value: "all", label: "Allt", count: counts.all },
    {
      value: "open",
      label: "Öppna ärenden",
      count: counts.open,
      icon: <WorkIcon sx={{ fontSize: 13 }} />,
    },
    {
      value: "cases",
      label: "Alla ärenden",
      count: counts.cases,
      icon: <WorkIcon sx={{ fontSize: 13 }} />,
    },
    {
      value: "activities",
      label: "Aktiviteter",
      count: counts.activities,
      icon: <BoltIcon sx={{ fontSize: 13 }} />,
    },
    {
      value: "future",
      label: "Kommande",
      count: counts.future,
      icon: <ClockIcon sx={{ fontSize: 13 }} />,
    },
  ];

  return (
    <Stack direction="row" gap={0.75} flexWrap="wrap" sx={{ pt: 0.5, pb: 1.75 }}>
      {chips.map((chip) => {
        const active = chip.value === value;
        return (
          <Box
            component="button"
            key={chip.value}
            onClick={() => onChange(chip.value)}
            sx={{
              display: "inline-flex",
              alignItems: "center",
              gap: 0.75,
              px: 1.5,
              py: 0.75,
              borderRadius: 999,
              fontSize: 13,
              fontWeight: 500,
              fontFamily: "inherit",
              cursor: "pointer",
              bgcolor: active ? ORANGE : PAPER,
              color: active ? "#fff" : INK,
              border: `1px solid ${active ? ORANGE : LINE}`,
              transition: "all .15s ease",
              "&:hover": {
                borderColor: active ? ORANGE : INK_4,
              },
            }}
          >
            {chip.icon}
            {chip.label}
            <Box
              component="span"
              sx={{
                fontSize: 11,
                px: 0.75,
                borderRadius: 999,
                bgcolor: active ? "rgba(255,255,255,.22)" : "rgba(0,0,0,.06)",
                color: active ? "#fff" : "inherit",
                fontWeight: 600,
              }}
            >
              {chip.count}
            </Box>
          </Box>
        );
      })}
    </Stack>
  );
};

export default TimelineFilters;
